import { Component,ViewChild, ElementRef } from '@angular/core';
import {API_ENDPOINT_CREATE,API_DOMAIN_URL, uxControls} from '../../config/constants';
import { QRCodeComponent } from 'angularx-qrcode';
import { FormsModule, FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';
import { SafeUrl } from '@angular/platform-browser';
import { ClipboardService } from 'ngx-clipboard';
import { StableLinkIntegrationService } from '../../core/services/stable-link-integration.service';
import { SupportEmailService } from '../../core/services/support-email.service';
import { OAuthService } from 'angular-oauth2-oidc';
import * as badWordsArray from './badwords/en.txt.json';
import { Timestamp } from '../../../timestamp/Timestamp';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent {
  @ViewChild("qrcode", {static : true}) qrcode: QRCodeComponent;
  isHovered = false;
  public originalUrl!: string;
  public shortUrl: string = "";
  public retentionInYears!: number;
  public isShortenUrl: boolean = false;
  public shortenUrl: string = '';
  public isValidUrl: boolean = false;
  public isValid_icon: string = "";
  public isValidUrlEM: boolean = false;
  public qrCodeDownloadLink: SafeUrl = "";
  public seeUrlS_val: string = '';
  public isFormDisabled: boolean = true;
  public seeUrlS_icon: string = "";
  public seeUrlInfo_val: string = '';
  public seeUrlInfo_no: number;
  public seeUrlInfo_icon: string = "";
  public isValid_val: string = '';
  public icon_warning: string = "\u2718";
  public icon_info: string = "\u2139";
  public icon_success: string = "\u2713";

  // Initialize flag and timer variable
  public timerWaiting: boolean = false;
  private typingTimer: any;
  public shortUrlInputFocused: boolean = false;

  public preferred_Username!: string;
  username = '';

  compiledTimestamp: string = Timestamp.stamp;
  
  // Maximum character limit for short URL
  public get maxShortUrlLength(): number {
    return uxControls.maximumCharacterShortName;
  }
  
  get token() {
    return this.oauthService.getAccessToken();
  }
  get claims() {
    return this.oauthService.getIdentityClaims();
  }

  ngOnInit() {
    // Call login() when the component initializes
    this.configService.login().subscribe(
      () => {
        console.log('Login successful');
        // Do any additional initialization tasks here
      },
      error => {
        // Handle login error
        console.error('Error during login:', error);
        this.oauthService.refreshToken();
        //sessionStorage.clear();
      }
    );
    this.oauthService.setupAutomaticSilentRefresh();
    
    // Add console log for token refresh events
    this.oauthService.events.subscribe(event => {
      if (event.type === 'token_received') {
        console.log('🔄 Token was auto-refreshed successfully at:', new Date().toISOString());
      }
    });
  }


  constructor(
    private configService: StableLinkIntegrationService,
    private oauthService: OAuthService,
    private clipboardService: ClipboardService,
    private supportEmailService: SupportEmailService
  ) {}

  onChangeURL(url: SafeUrl) {
    this.qrCodeDownloadLink = url;
  }
  
  copyContent() {
    this.clipboardService.copyFromContent(this.shortenUrl);
  }
  
  // this function to reset all flags to default values for new URL shortening
  getToNewShortURL() {
    this.isShortenUrl = false;
    this.isValidUrl = false;
    this.isFormDisabled  = true; 
  }

  checkIsValidURL(event) {
    this.isValidUrl = false;
    this.isValidUrlEM = false;
    const urlRegex =
      '^https?://(?:.*?.)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
      // Explanation of pattern:
      // ^https?:// - Ensures the URL starts with http:// or https://
      // (?:.*?.)? - Non-capturing group to optionally match subdomains
      // ([\\da-z.-]+) - Captures the main domain name (letters, digits, hyphens, dots)
      // \\.([a-z.]{2,6}) - Captures the top-level domain (like .com, .org)
      // [/\\w .-]*/? - Matches the rest of the URL path (optional)
      // This will now:
      // ✅ Allow: "http://example.com"
      // ✅ Allow: "https://example.com"
      // ✅ Allow: "http://sub.example.com"
      // ✅ Allow: "https://sub.example.com/path"
      // ❌ Prevent: "ftp://example.com" (invalid protocol)
      // ❌ Prevent: "example.com" (missing protocol)
      // ❌ Prevent: "http://example" (missing top-level domain)

    if (event.target.value) {
      const regix = new RegExp(urlRegex);
      this.isValidUrlEM = !regix.test(event.target.value);
      this.isValid_val = 'Please provide a valid URL.';
      this.isFormDisabled = true;
      this.isValid_icon = this.icon_warning;
      if (!this.isValidUrlEM) {
        this.isValidUrl = true;
        this.isValid_val = 'Correct';
        //Let the first URL function run independently, but if length of second field is empty allow green
        if (this.shortUrl?.length === 0) { this.isFormDisabled = true; }
        this.isValid_icon = this.icon_success;
        this.seeUrlS();
      }
    }
  }

    // Step 3: Create a new method for keyup event handling
  handleKeyUp() {
    this.timerWaiting = true; // Start waiting
    clearTimeout(this.typingTimer); // Clear existing timer
    if (this.shortUrl?.length < 3 ) {this.seeUrlS();return;} // Exit if the length is less than 3
    
    //setting initial status of checking message

    //Uncomment this line if you want to show info message "Checking ... in validation message"
    this.seeUrlS_icon = this.icon_warning;

    this.typingTimer = setTimeout(() => {
      this.timerWaiting = false; // Stop waiting
      this.seeUrlS(); // Now call seeUrlS() as the timer has finished
    }, 1500); // Set timer for 1.5 seconds
  }

  // Displays warning message if the short URL is not valid
  seeUrlS() {
    const badWordsRegexData = (badWordsArray as any).default.join('|');

    const shortUrlRegex_alphaNumeric = `^(?=.*[a-zA-Z0-9])[a-zA-Z0-9\\-\\_\\.\\~]+$`;
      // Explanation of pattern:
      // ^ - Start of string
      // (?=.*[a-zA-Z0-9]) - Positive lookahead to ensure at least one alphanumeric character exists
      // [a-zA-Z0-9\\-\\_\\.\\~]+ - One or more alphanumeric or special characters
      // $ - End of string
      // This will now:
      // ✅ Allow: "abc---def" (valid - repetitive special characters with alphanumeric)
      // ✅ Allow: "abc...def" (valid - repetitive special characters with alphanumeric)
      // ✅ Allow: "abcdef" (valid - only alphanumeric)
      // ✅ Allow: "abc~~~def" (valid - repetitive special characters with alphanumeric)
      // ✅ Allow: "abc-.-def" (valid - mixed special characters with alphanumeric)
      // ❌ Prevent: "---" (invalid - only special characters)
      // ❌ Prevent: "..." (invalid - only special characters)
      // ❌ Prevent: "~~~" (invalid - only special characters)
      // ❌ Prevent: "-.-" (invalid - only special characters)
    const shortUrlregix_alphaNumeric = new RegExp(shortUrlRegex_alphaNumeric);
    const shortUrl_isValidUrlEM_alphaNumeric = shortUrlregix_alphaNumeric.test(this.shortUrl);

    const shortUrlRegex_badWording = `(${badWordsRegexData})`;
    const shortUrlregix_badWording = new RegExp(shortUrlRegex_badWording);
    const shortUrl_isValidUrlEM_badWording = !shortUrlregix_badWording.test(this.shortUrl);

    const isRegex = shortUrl_isValidUrlEM_alphaNumeric && shortUrl_isValidUrlEM_badWording;
    this.seeUrlS_icon = this.icon_warning;
    switch (true) {

      case this.shortUrl?.length === 0:
        this.isFormDisabled = false;
        break;
      // case if length is more than 3 chars and characters are alphanumeric
      case this.shortUrl?.length >= 3 && isRegex:
        if (this.timerWaiting) return; // Exit if we're waiting for the timer
        this.seeUrlS_val = API_DOMAIN_URL + this.shortUrl;
        this.isFormDisabled = false;
        this.seeUrlS_icon = this.icon_success;
        
        // Use the availability check endpoint
        this.configService.get(API_ENDPOINT_CREATE + "/" + this.shortUrl + "/availability", { responseType: 'json' }).subscribe(
          (response: any) => {
            console.log('Availability check response:', response);
            // Both 200 and 409 responses have the same structure with available boolean
            if (response && response.available === false) {
              // Link is not available - format the message if it contains a date
              let message = response.message || "Link reserved already";
              message = this.formatDateInMessage(message);
              this.seeUrlS_val = message;
              this.isFormDisabled = true;
              this.seeUrlS_icon = this.icon_warning;
            } else if (response && response.available === true) {
              // Link is available
              this.seeUrlS_val = API_DOMAIN_URL + this.shortUrl;
              this.isFormDisabled = false;
              this.seeUrlS_icon = this.icon_success;
            } else {
              // Unexpected response format
              this.seeUrlS_val = "Unable to check availability. Please try again.";
              this.isFormDisabled = true;
              this.seeUrlS_icon = this.icon_warning;
            }
          },
          (error) => {
            console.log('Availability check error:', error);
            if (error.status === 409 && error.error) {
              // 409 Conflict - Link is already reserved
              const errorResponse = error.error;
              let message = errorResponse.message || "Link reserved already";
              message = this.formatDateInMessage(message);
              this.seeUrlS_val = message;
              this.isFormDisabled = true;
              this.seeUrlS_icon = this.icon_warning;
            } else {
              // Other errors - treat as unavailable for safety
              this.seeUrlS_val = "Unable to check availability. Please try again.";
              this.isFormDisabled = true;
              this.seeUrlS_icon = this.icon_warning;
            }
          }
        );
        break;

      // case characters are non-alphanumeric
      case !shortUrl_isValidUrlEM_alphaNumeric:
        this.seeUrlS_val = "Letters, numbers, and few special characters (-, _, ., ~) are allowed if used with letters or numbers.";
        this.isFormDisabled = true;
        break;

      // case any bad wording detected 
      case !shortUrl_isValidUrlEM_badWording:
        this.seeUrlS_val = "Sorry, swear words are not acceptable!";
        this.isFormDisabled = true;
        break;

      // case if length is less than 3 chars
      case this.shortUrl?.length < 3 && this.shortUrl?.length !== 0:
        this.seeUrlS_val = `Type 3 to ${this.maxShortUrlLength} alphanumeric characters`;  
        this.isFormDisabled = true;
        break;

      default:
        this.seeUrlS_val = "";
        this.isFormDisabled = true;
        break;
    }
  }

  getShortURL() {
    const data = [
      {
        creator: this.oauthService.getIdentityClaims()['preferred_username'], // this.creator,
        url: this.originalUrl,
        shortUrlId: this.shortUrl,
        retentionInYears: 1, // Hard coding this value to 1, please use retentionInYears in-case value needs to be collected from UI.
      },
    ];
    this.configService.post(API_ENDPOINT_CREATE, data, '').subscribe((resp) => {
      console.log(resp);

      if (resp !== null) {
        this.isShortenUrl = true;
        this.shortenUrl = API_DOMAIN_URL + resp['shortUrlIds'][0].shortUrlId;
        this.originalUrl = "";
        this.shortUrl = "";
      }
    });
  }

  getEmailTemplate(): string {
    // Use shared service with browser info included
    return this.supportEmailService.getEmailTemplate(true);
  }

  // Handle focus event for short URL input
  onShortUrlFocus() {
    this.shortUrlInputFocused = true;
  }

  // Handle blur event for short URL input
  onShortUrlBlur() {
    this.shortUrlInputFocused = false;
  }

  // Format ISO dates in messages to user-friendly format
  formatDateInMessage(message: string): string {
    // Look for ISO date pattern in the message (e.g., 2026-04-01T13:20:58.391000)
    const isoDateRegex = /(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{3,6})?)/g;
    
    return message.replace(isoDateRegex, (match) => {
      try {
        const date = new Date(match);
        // Format as: April 1, 2026 at 1:20 PM
        return date.toLocaleDateString('en-US', { 
          year: 'numeric', 
          month: 'long', 
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          hour12: true
        });
      } catch (error) {
        // If date parsing fails, return the original string
        return match;
      }
    });
  }

}